'use client';

import { c as _c } from "react/compiler-runtime";
import { useActiveWalletSlot, useInvalidateWalletCache, useWallets } from '@morfi/backend-sdk-v2/client';
import { resolveManualTransferWallet } from '@morfi/onramp-sdk';
import { useState } from 'react';
import { getUsdcMint } from '@/config/solana';
import { useActiveNetwork } from '@/lib/network/use-active-network';
import { usePortfolioWalletSelectionStore } from '@/stores/portfolio-wallet-selection';
export function useManualTransferWallet() {
  const $ = _c(18);
  const {
    wallets,
    isLoading,
    error
  } = useWallets();
  const {
    activeWalletId,
    isHydrated
  } = useActiveWalletSlot();
  const invalidate = useInvalidateWalletCache();
  const network = useActiveNetwork();
  const selection = usePortfolioWalletSelectionStore(_temp);
  const [retrying, setRetrying] = useState(false);
  const loading = isLoading || !isHydrated || retrying;
  let t0;
  if ($[0] !== activeWalletId || $[1] !== error || $[2] !== loading || $[3] !== selection || $[4] !== wallets) {
    t0 = loading || error ? null : resolveManualTransferWallet(wallets, activeWalletId, selection === "active" || selection === "all" ? null : selection);
    $[0] = activeWalletId;
    $[1] = error;
    $[2] = loading;
    $[3] = selection;
    $[4] = wallets;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const wallet = t0;
  const address = wallet?.address ?? null;
  let t1;
  if ($[6] !== invalidate) {
    t1 = function retry() {
      setRetrying(true);
      return invalidate().finally(() => setRetrying(false));
    };
    $[6] = invalidate;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const retry = t1;
  const t2 = loading ? "loading" : address ? "ready" : "unavailable";
  let t3;
  if ($[8] !== address || $[9] !== network) {
    t3 = address ? `solana:${address}?spl-token=${getUsdcMint(network)}` : null;
    $[8] = address;
    $[9] = network;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = loading || address ? null : error ? "wallet_load_failed" : "no_eligible_wallet";
  let t5;
  if ($[11] !== address || $[12] !== network || $[13] !== retry || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = {
      status: t2,
      address,
      qrValue: t3,
      network,
      errorCode: t4,
      retry
    };
    $[11] = address;
    $[12] = network;
    $[13] = retry;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function _temp(state) {
  return state.selection;
}